/**
 * Develve un numero random entre 0 y el max especificado - 1
 *
 * @param {number} max maximo valor posible (excluyente)
 * @returns numero random entre 0 y max - 1
 */
export function rnd(max) {
    return Math.floor((Math.random() * max));
}
/**
 * Devuelve un string de un numero random entre 1 y el especificado
 *
 * @param {number} max maximo valor posible (inclusive)
 * @returns string de un numero random entre 1 y max
 */
export function number(max) {
    return (rnd(max) + 1).toString();
}
/**
 * Devuelve un boolean random
 *
 * @returns true o false
 */
export function boolean() {
    return item([true, false]);
}
/**
 * Devuelve un item al azar de la lista de items especificada.
 *
 * @template T tipo de item en la lista
 * @param {T[]} list lista de items de la cual se toma el item
 * @returns un item al azar de dicha lista
 */
export function item(list) {
    return list[rnd(list.length)];
}
/**
 * Devuelve una letra minuscula al azar
 *
 * @returns letra al azar
 */
export function letter() {
    return String.fromCharCode(rnd(25) + 65);
}
//# sourceMappingURL=random.js.map